export default __webpack_public_path__ + "static/media/1.03fef8c7.png";